import { render, staticRenderFns } from "./AddChecklistDialog.vue?vue&type=template&id=423d8c04"
import script from "./AddChecklistDialog.vue?vue&type=script&lang=ts"
export * from "./AddChecklistDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports